import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=0e07a62c&scoped=true"
import script from "./productCenter.vue?vue&type=script&lang=js"
export * from "./productCenter.vue?vue&type=script&lang=js"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=0e07a62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07a62c",
  null
  
)

export default component.exports